// Código de categoría → descripción. Copia exacta del mapa `I` de Calma
// (utils_.ac9d7b60.js). Incluye categorías numéricas + etiquetas (GEN, YA, LAT, ...).
export const CATEGORIA_NOMBRES = new Map([
    ["1", "Huevos y derivados"],
    ["1.1", "Claras de huevo y derivados"],
    ["1.2", "Huevos"],
    ["1.2.1", "Huevos frescos"],
    ["1.2.2", "Huevos preparados"],
    ["2", "Carnes"],
    ["2.1", "Embutidos"],
    ["2.2", "Aves"],
    ["2.2.1", "Aves frescas"],
    ["2.2.2", "Aves preparadas"],
    ["2.2.3", "Aves ya cocinadas"],
    ["2.2.4", "Aves congeladas"],
    ["2.2.6", "Hamburguesas fitness de pollo o pavo (gama Fitness Burger)"],
    ["2.2.8", "Aves en lata"],
    ["2.3", "Vacuno o buey"],
    ["2.3.1", "Vacuno o buey fresco"],
    ["2.3.2", "Vacuno o buey preparado"],
    ["2.3.3", "Vacuno o buey ya cocinado"],
    ["2.3.4", "Vacuno o buey congelado"],
    ["2.3.6", "Hamburguesas fitness de ternera o buey (gama Fitness Burger)"],
    ["2.3.8", "Vacuno en lata"],
    ["2.4", "Cerdo"],
    ["2.4.1", "Cerdo fresco"],
    ["2.4.2", "Cerdo preparado"],
    ["2.4.3", "Cerdo ya cocinado"],
    ["2.4.4", "Cerdo congelado"],
    ["2.4.8", "Cerdo en lata"],
    ["2.6", "Otras carnes blancas"],
    ["2.7", "Otras carnes rojas"],
    ["2.7.1", "Cordero"],
    ["2.7.2", "Wagyu"],
    ["2.7.3", "Potro"],
    ["3", "Pescados y mariscos"],
    ["3.1", "Pescado fresco"],
    ["3.2", "Pescado preparado"],
    ["3.3", "Pescado ya cocinado"],
    ["3.4", "Pescado congelado"],
    ["3.7", "Pescados ahumados"],
    ["3.8", "Conservas de pescado"],
    ["3.9", "Mariscos"],
    ["3.9.1", "Marisco fresco"],
    ["3.9.2", "Marisco preparado"],
    ["3.9.3", "Marisco ya cocinado"],
    ["3.9.4", "Marisco congelado"],
    ["3.9.8", "Mariscos en conserva"],
    ["4", "Proteínas en polvo"],
    ["4.1", "Proteína de suero"],
    ["4.1.1", "Aislado de suero"],
    ["4.1.2", "Proteína de suero nativa"],
    ["4.1.3", "Concentrado de suero"],
    ["4.2", "Proteína de caseína o mezcla de suero + caseina"],
    ["4.3", "Proteína vegetal en polvo"],
    ["5", "Lácteos y derivados"],
    ["5.1", "Leche"],
    ["5.2", "Yogures y derivados"],
    ["5.2.1", "Yogures normales"],
    ["5.2.2", "Yogures desnatados"],
    ["5.2.3", "Yogures y quesos batidos altos en proteínas"],
    ["5.3", "Quesos"],
    ["5.3.5", "Queso proteico"],
    ["5.4", "Batidos proteicos comerciales"],
    ["5.5", "Tartas proteicas My Fitness Meals"],
    ["5.6", "Batidos comerciales"],
    ["5.7", "Nata"],
    ["5.8", "Mantequilla y margarina"],
    ["6", "Soja"],
    ["6.1", "Leche de Soja"],
    ["6.2", "Otros derivados de la soja"],
    ["7", "Cereales (excepto arroz)"],
    ["7.1", "Cereales de desayuno"],
    ["7.1.1", "Cereales comerciales"],
    ["7.1.2", "Cereales integrales"],
    ["7.1.3", "Cereales proteicos"],
    ["7.2", "Harinas de cereales"],
    ["7.2.1", "Harinas de trigo"],
    ["7.2.2", "Harinas de avena"],
    ["7.2.3", "Harinas de maíz, espelta y otros cereales (excepto trigo y avena)"],
    ["7.3", "Maíz, espelta y otros cereales (no harinas ni tortitas)"],
    ["7.4", "Tortitas de maíz y otros cereales"],
    ["7.5", "Cereales solubles y papillas de cereales"],
    ["7.6", "Tortillas de maíz y otros cereales (excepto trigo)"],
    ["8", "Panes y tortillas de trigo"],
    ["8.1", "Pan de barra blanco"],
    ["8.2", "Pan de barra integral"],
    ["8.3", "Pan wasa o similar"],
    ["8.4", "Picatostes y pan tostado normal"],
    ["8.9", "Picatostes y pan tostado integral"],
    ["8.5", "Tortillas de trigo"],
    ["8.6", "Pan de molde blanco"],
    ["8.7", "Pan de molde integral"],
    ["8.8", "Panes enriquecidos en proteínas"],
    ["8.10", "Masa para pizza, obleas y hojaldre"],
    ["9", "Tubérculos y derivados"],
    ["10", "Legumbres"],
    ["10.1", "Legumbres en conserva, al minuto, congeladas o hechas pasta"],
    ["10.1.4", "Legumbres congeladas"],
    ["10.1.7", "Legumbres hechas pasta"],
    ["10.1.8", "Legumbres en conserva"],
    ["10.1.9", "Legumbres al minuto"],
    ["10.2", "Legumbres crudas"],
    ["11", "Fruta, zumo, potitos y mermeladas"],
    ["11.1", "Fruta fresca"],
    ["11.4", "Fruta congelada"],
    ["11.5", "Zumos y derivados"],
    ["11.6", "Potitos"],
    ["11.7", "Frutas secas"],
    ["11.8", "Fruta en conserva"],
    ["11.8.1", "Fruta en conserva con azúcares añadidos"],
    ["11.8.2", "Fruta en conserva sin azúcares añadidos"],
    ["11.9", "Mermeladas"],
    ["13", "Verduras y hortalizas"],
    ["13.1", "Verduras y hortalizas frescas"],
    ["13.2", "Cremas de verdura y gazpacho"],
    ["13.4", "Verduras y hortalizas congeladas"],
    ["13.8", "Verduras y hortalizas en conserva"],
    ["13.9", "Ensaladas preparadas"],
    ["14", "Hidratos en polvo"],
    ["16", "Salsas, siropes y konjac"],
    ["16.1", "Salsas o siropes zero o muy bajas en kcal"],
    ["16.2", "Salsas o siropes con azúcar y/o grasa"],
    ["16.3", "Siropes proteicos"],
    ["16.4", "Konjac y derivados"],
    ["17", "Alimentos ricos en grasas de todo tipo"],
    ["17.1", "Aceites vegetales y derivados"],
    ["17.1.1", "Aceite de oliva"],
    ["17.1.2", "Aceitunas"],
    ["17.1.3", "Otros aceites vegetales"],
    ["17.2", "Frutos secos (naturales o cremas) y semillas"],
    ["17.2.1", "Frutos secos sin grasas y/o azúcares añadidos"],
    ["17.2.2", "Frutos secos con grasas y/o azúcares añadidos"],
    ["17.2.3", "Semillas"],
    ["17.2.4", "Cremas de frutos secos sin grasas y/o azúcares añadidos"],
    ["17.2.5", "Cremas de frutos secos con grasas y/o azúcares añadidos"],
    ["17.2.6", "Frutos secos en polvo"],
    ["17.4", "Mantequilla y margarina"],
    ["17.5", "Cremas de cacao y cremas proteicas"],
    ["17.5.1", "Cremas de cacao con azúcares y/o grasas añadidos"],
    ["17.5.2", "Cremas de cacao con edulcorantes"],
    ["17.5.3", "Cremas proteicas"],
    ["17.6", "Aguacate y derivados"],
    ["17.7", "Cremas vegetales"],
    ["17.9", "Croquetas"],
    ["17.9.2", "Croquetas preparadas"],
    ["17.9.3", "Croquetas ya cocinadas"],
    ["17.10", "Mayonesa"],
    ["18", "Intraentrenamiento"],
    ["18.1", "Bebidas isotónicas"],
    ["18.1.1", "Bebidas isotónicas con azucar"],
    ["18.1.2", "Bebidas isotónicas sin azucar"],
    ["18.3", "Hidratos de carbono en polvo para entrenar"],
    ["19", "Bebidas energéticas, refrescos y cafés"],
    ["19.1", "Bebidas energéticas y refrescos con azúcar"],
    ["19.2", "Bebidas energéticas y refrescos sin azúcar"],
    ["19.3", "Café"],
    ["19.3.1", "Cafés preparados"],
    ["19.3.2", "Cafés fríos"],
    ["19.3.3", "Café en polvo"],
    ["21", "Arroces y derivados"],
    ["21.1", "Arroces"],
    ["21.2", "Tortas de arroz"],
    ["21.3", "Cremas de arroz y harinas de arroz"],
    ["21.4", "Fideos de arroz"],
    ["22", "Pasta, quinoa y derivados"],
    ["22.1", "Pasta"],
    ["22.1.1", "Pasta seca"],
    ["22.1.2", "Pasta fresca"],
    ["22.1.2.1", "Pasta fresca sin relleno"],
    ["22.1.2.2", "Pasta fresca rellena"],
    ["22.1.3", "Pasta proteica"],
    ["22.2", "Fideos"],
    ["22.3", "Bulgur"],
    ["22.4", "Cous cous"],
    ["22.5", "Quinoa"],
    ["22.6", "Pasta Gnocchi (ñoquis)"],
    ["24", "Bebidas vegetales"],
    ["25", "Postentreno"],
    ["27", "Sustitutivos de comidas"],
    ["27.1", "Sustitutivos de comidas en polvo"],
    ["27.2", "Sustitutivos de comidas My Fitness Meals"],
    ["28", "Proteína vegetal"],
    ["29", "Barritas proteicas"],
    ["30", "Proteína en polvo y barritas proteicas"],
    ["31", "Bollería industrial y galletas"],
    ["32", "Pizza, lasaña, empanadas y empanadillas"],
    ["34", "Chocolates y chocolatinas"],
    ["35", "Helados"],
    ["35.1", "Helados fit"],
    ["35.2", "Helados fat"],
    ["36", "Postres"],
    ["37", "Cacao en polvo y azúcares de todo tipo, chucherías y miel"],
    ["38", "Aperitivos"],
    ["38.1", "Patatas fritas y derivados"],
    ["38.2", "Frutos secos"],
    ["38.3", "Paté y Foie-gras"],
    ["39", "Cocina tradicional española"],
    ["40", "Casquería"],
    ["41", "Aminoacidos para entrenar"],
    ["42", "Alimentos ricos en grasas de buena calidad"],
    ["43", "Bollería, galletas, barritas energéticas, chocolate y chocolatinas"],
    ["44", "Helados y postres"],
    ["45", "Otras carnes"],
    ["46", "Cremas y tortas de arroz"],
    ["47", "Barritas energéticas"],
    ["48", "Sopas y Caldos"],
    ["49", "Comida rápida"],
    ["50", "Comida asiática"],
    ["50.1", "Comida japonesa"],
    ["50.1.1", "Sushi y derivados"],
    ["50.1.2", "Gyozas"],
    ["50.2", "Comida china"],
    ["51", "Superalimentos"],
    ["52", "Mundo vegano"],
    ["53", "Comida preparada"],
    ["GEN", "Sin marca"],   // antes «Genérico» (Jesús, 27-09)
    ["PRO", "Marca recomendada con descuento especial"],
    ["FRE", "Frescos"],
    ["CGE", "Congelados"],
    ["AHU", "Ahumados"],
    ["LAT", "Conservas"],
    ["POL", "En Polvo"],
    ["PRE", "Preparado"],
    ["HAM", "Carne picada y hamburguesas"],
    ["SNA", "Snacks fáciles de transportar"],
    ["YA", "Listo para comer"],
    ["MIN", "1 Minuto al micro y listo"],
    ["YCO", "Ya cocinados"],
    ["UNI", "Ya pesado"],
    ["SGL", 'Etiquetado "Sin gluten"'],
    ["SLC", "Sin lactosa"],
    ["SHV", "Sin huevo"],
    ["TOP", "Alimentos frecuentes"],
    ["NAV", "Especial Navidad HO HO HO!"],
]);

// Calma `Q`: descripción de un código; si no existe, sube al padre (quita el último `.x`).
export const descripcionCategoria = (code) => {
    if (!code) return undefined;
    const v = CATEGORIA_NOMBRES.get(code);
    if (v != null) return v;
    const i = code.lastIndexOf('.');
    return i === -1 ? undefined : descripcionCategoria(code.substring(0, i));
};
